import DoneIcon from "@mui/icons-material/Done";
import { Grid, Icon, styled, Typography } from "@mui/material";
export default function SuccesssBox({
  message,
  isReviewModal = false,
}: {
  message: string;
  isReviewModal?: boolean;
}) {
  const SuccessBoxContainer = styled(Grid)`
    border: ${({ theme }) => `1px solid ${theme.palette.primary.main}`};
    padding: 0.5rem;
  `;
  return (
    <SuccessBoxContainer container sx={{ marginBottom: "1rem" }}>
      <Grid item xs={2} sm={1.2}>
        <Icon
          component={DoneIcon}
          color="primary"
          sx={{ fontSize: isReviewModal ? "2.5rem" : "3rem" }}
        />
      </Grid>
      {isReviewModal ? (
        <Grid item xs={10} sx={{ paddingLeft: "10px" }}>
          <Typography color="primary" style={{ display: "flex" }}>
            Success
          </Typography>
          <Typography
            sx={{ fontSize: "0.8rem", display: "flex", textAlign: "left" }}
          >
            {message}
          </Typography>
        </Grid>
      ) : (
        <Grid item xs={10} sm={10.8}>
          <Typography color="primary">Success</Typography>
          <Typography sx={{ fontSize: "0.8rem" }}>{message}</Typography>
        </Grid>
      )}
    </SuccessBoxContainer>
  );
}
